import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'financeiro/servico', ptBr);
i18next.addResourceBundle('en', 'financeiro/servico', en);

const ServicoConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/vendas-servicos/servico',
      component: React.lazy(() => import('./Servico')),
    },
  ],
};

export default ServicoConfig;
